import { Badge, Button, makeStyles, MessageBar, MessageBarBody, tokens } from '@fluentui/react-components';
import { useAuthorizationStep } from '.';

export function Finnish() {
	const { authorization, onClose } = useAuthorizationStep();
	const styles = useStyles();

	return (
		<div className={styles.root}>
			<div className={styles.content}>
				<div className={styles.titleRoot}>
					<h1 className={styles.title}>
            Make it even more seamless
					</h1>
					<Badge color="informative" appearance="filled" size="small" className={styles.badge}>Recommended</Badge>
				</div>
				<p>
          Right now, your rules run using your own Azure DevOps account. That works fine, but if your access ever changes, those rules could stop running with it.
					<br />
					<br />
					{'To avoid that, ask an Azure DevOps admin to add Appgami Automation as a user in your organization. Once it\'s added, you can switch your rules to run under that account instead of your own, so they keep working no matter what happens to your personal access.'}
				</p>
			</div>
			<div className={styles.messageBarWrapper}>
				{
					!authorization.service && (
						<MessageBar intent="info" layout="multiline">
							<MessageBarBody>
								{'Go to Organization settings → Users → Add users and search for "Appgami Automation."'}
							</MessageBarBody>
						</MessageBar>
					)
				}
				{
					authorization.service && (
						<MessageBar intent="success" layout="multiline">
							<MessageBarBody>
								{'The user "Appgami Automation" has already been added to your Azure DevOps, and is ready to be used in your automations!'}
							</MessageBarBody>
						</MessageBar>
					)
				}
			</div>
			{
				onClose && (
					<div className={styles.bottomRoot}>
						<div className={styles.BottombuttonArea}>
							<Button appearance="primary" onClick={onClose}>{'Let\'s go'}</Button>
						</div>
					</div>
				)
			}
			<div className={styles.bottomRoot}>
				<div className={styles.Bottomline} />
			</div>
			<div className={styles.helpTextWrapper}>
				<span className={styles.helpText}>
					Need help? <a href='https://appgami.atlassian.net/servicedesk/customer/portal/2' target='_blank' rel='noopener noreferrer'>Get in touch</a> with Appgami or email us at <a target='_blank' rel='noopener noreferrer' href='mailto:support@appgami.com'>support@appgami.com</a>
				</span>
			</div>
		</div>
	);
}

const useStyles = makeStyles({
	root: {
		padding: '32px 24px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
	},
	content: {
		maxWidth: '600px',
		textAlign: 'center',
		padding: '0px 0px 32px 0px'
	},
	titleRoot: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '8px',
		marginBottom: '16px',
	},
	title: {
		fontSize: '24px',
		fontWeight: tokens.fontWeightSemibold,
		color: tokens.colorNeutralForeground1,
		textAlign: 'center',
	},
	badge: {},
	bottomRoot: {
		width: '100%',
		maxWidth: '600px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		gap: '16px',
	},
	Bottomline: {
		display: 'block',
		width: '100%',
		height: '1px',
		backgroundColor: tokens.colorSubtleBackgroundSelected,
		marginBottom: '16px',
		marginTop: '32px',
	},
	BottombuttonArea: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '8px',
		width: '100%',
		marginTop: '16px',
	},
	messageBarWrapper: {
		boxSizing: 'border-box',
		padding: '0px 0px 16px 0px',
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		maxWidth: '600px',
	},
	notNowText: {
		color: tokens.colorNeutralForeground1,
		fontWeight: tokens.fontWeightRegular,
	},
	notAdminText: {
		color: tokens.colorNeutralForeground1,
		fontWeight: tokens.fontWeightRegular,
	},
	bottomButtonAreaText: {
		color: tokens.colorNeutralForeground1,
		fontWeight: tokens.fontWeightRegular,
		fontSize: '14px',
		textAlign: 'center',
	},
	bottomButtonAreaTextStrong: {
		color: tokens.colorNeutralForeground1,
		fontWeight: tokens.fontWeightSemibold,
	},
	helpTextWrapper: {
		padding: '0px 0px 16px 0px',
	},
	helpText: {
		color: tokens.colorNeutralForeground1,
		fontWeight: tokens.fontWeightRegular,
		fontSize: '14px',
		textAlign: 'center',
		'& a': {
			color: tokens.colorBrandForeground1,
			fontWeight: tokens.fontWeightRegular,
			textDecoration: 'underline',
			cursor: 'pointer',
		},
	},
});